/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type PurchasedGoodsReviewListSortItem = typeof PurchasedGoodsReviewListSortItem[keyof typeof PurchasedGoodsReviewListSortItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchasedGoodsReviewListSortItem = {
  remoteId: 'remoteId',
  '-remoteId': '-remoteId',
  site: 'site',
  '-site': '-site',
  supplier: 'supplier',
  '-supplier': '-supplier',
  packagingName: 'packagingName',
  '-packagingName': '-packagingName',
  packagingType: 'packagingType',
  '-packagingType': '-packagingType',
  packagingSize: 'packagingSize',
  '-packagingSize': '-packagingSize',
  CarbonIntensityCategory: 'CarbonIntensityCategory',
  '-CarbonIntensityCategory': '-CarbonIntensityCategory',
  source: 'source',
  '-source': '-source',
  gas: 'gas',
  '-gas': '-gas',
  fuel: 'fuel',
  '-fuel': '-fuel',
  logisticsFlow: 'logisticsFlow',
  '-logisticsFlow': '-logisticsFlow',
  flowType: 'flowType',
  '-flowType': '-flowType',
  emissionFactor: 'emissionFactor',
  '-emissionFactor': '-emissionFactor',
  quantity: 'quantity',
  '-quantity': '-quantity',
  emissions: 'emissions',
  '-emissions': '-emissions',
  scope3Emissions: 'scope3Emissions',
  '-scope3Emissions': '-scope3Emissions',
  totalSpend: 'totalSpend',
  '-totalSpend': '-totalSpend',
  costPerKg: 'costPerKg',
  '-costPerKg': '-costPerKg',
  costPerUnit: 'costPerUnit',
  '-costPerUnit': '-costPerUnit',
  created: 'created',
  '-created': '-created',
} as const;
